import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PaleSkyCloseIcon } from '@src/images/image-imports';

/**
 * Renders an input box with a clear button and on change handler.
 */
const SearchBox = ({ placeholder, changeHandler }) => {
  const [input, setInput] = useState('');

  const handleChange = (event) => {
    const text = event.target.value.trimStart();
    setInput(text);
    changeHandler(text);
  };

  const onClear = () => {
    const text = '';
    setInput(text);
    changeHandler(text);
  };

  const hasInput = input.length > 0;

  return (
    <div className='filter-input-group'>
      <input className='filter-search' type='text' placeholder={placeholder} onChange={handleChange} value={input} />
      {
        hasInput &&
        <button
          className='clear-search-button styleless-button'
          onClick={onClear}
          type='button'
        >
          <PaleSkyCloseIcon />
        </button>
      }
    </div>
  );
}

SearchBox.propTypes = {
  /**
   * the text to show before any user input
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * the callback function for when the user input is changed
   */
  changeHandler: PropTypes.func.isRequired,
};

export default SearchBox;
